module.exports = __webpack_public_path__ + "static/media/favorites_tablet.2aeb3838.jpg";